import {
  configureStore,
  ThunkAction,
  Action,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import vehicleReducer from './slices/vehicleSlice';
import dealerReducer from './slices/dealerSlice';
import estimatePaymentsSlice from './slices/estimatePaymentsSlice';
import zipcodeReducer from './slices/zipcodeSlice';
import savedConfigReducer from './slices/savedConfigSlice';
import pageContentReducer from './slices/pageContentSlice';
import adxReducer from './slices/adxSlice';
import metadataReducer from './slices/metadataSlice';

import { combineReducers } from 'redux';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  vehicle: vehicleReducer,
  dealer: dealerReducer,
  estimatePayments: estimatePaymentsSlice,
  pageContent: pageContentReducer,
  zipcode: zipcodeReducer,
  savedConfig: savedConfigReducer,
  adx: adxReducer,
  metadata: metadataReducer
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['dealer'], //blacklisting a store attribute name, will not persist that store attribute.
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // middleware option needs to be provided for avoiding the error. ref: https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
